module.exports = __webpack_public_path__ + "static/media/cafe_blank.51920adb.png";